import "@theme/front/init.scss";

import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tab";

import {initScroll} from "./front/scroll";
import {onScroll} from "./front/navbar";

import {initMap} from "./front/map";
window.initMap = initMap;

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

document.addEventListener("DOMContentLoaded", () => {
	const navbar = $(".navbar");

	$(".navbar-toggler").off("click").on("click", function () {
		const isShown = $(this).hasClass("collapsed");

		if (isShown) {
			navbar.addClass("navbar-shown");
		} else {
			navbar.removeClass("navbar-shown");
		}
	});

	initScroll();
	onScroll();

	window.addEventListener("scroll", function () {
		onScroll();
	});

	let mapInitialized = false;

	function initMap() {
		if ((window.scrollY * 2) > window.innerHeight && !mapInitialized) {
			const s = document.createElement("script");
			s.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=AIzaSyCqCWwkCMMmYSottP5qApqoY1I2QMIc8sU&callback=initMap");
			document.body.appendChild(s);
			mapInitialized = true;
		}
	}

	initMap();

	$(document).scroll(function () {
		initMap();
	});
});
